import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Diamond_1, leaderboard_bg, Diamond_2, Diamond_3 } from "../constants/icons";
import api from "../services/api";
import { useMediaQuery } from "../hooks/useMediaQuery";

const Leaderboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [leaderboardData, setLeaderboardData] = useState({
    top_clubs: [],
    top_agency: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [viewType, setViewType] = useState("clubs"); // "clubs" or "agents"

  useEffect(() => {
    // Determine view type from URL params or default to clubs
    const params = new URLSearchParams(location.search);
    const type = params.get("type") || "clubs";
    setViewType(type);

    const fetchLeaderboard = async () => {
      try {
        const response = await api.get("/users/tp-leader-board/");
        console.log(response.data, "leaderboard");
        if (response.data) {
          setLeaderboardData({
            top_clubs: response.data.top_clubs || [],
            top_agency: response.data.top_agency || [],
          });
        }
      } catch (error) {
        console.error("Failed to fetch leaderboard:", error);
        setError("Failed to load leaderboard data");
      } finally {
        setLoading(false);
      }
    };

    fetchLeaderboard();
  }, [location.search]);

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleClubClick = (clubId) => {
    navigate(`/search/club/${clubId}`);
  };

  const handleAgencyClick = (agencyId) => {
    navigate(`/search/agency/${agencyId}`);
  };

  const getRankingStyle = (rank) => {
    switch (rank) {
      case 1:
        return {
          background: "#FFDE78",
          border: "7.3px solid transparent",
          backgroundImage: `
            linear-gradient(#FFDE78, #FFDE78),
            linear-gradient(142.35deg, #8C421D 22.68%, #FBE67B 42.5%, #FCFBE7 55.31%, #F7D14E 69.6%, #D4A041 83.62%)
          `,
          backgroundOrigin: "border-box",
          backgroundClip: "padding-box, border-box",
          color: "#1F2A37",
        };
      case 2:
        return {
          background: "#F1F6FA",
          border: "6.3px solid transparent",
          backgroundImage: `
            linear-gradient(#F1F6FA, #F1F6FA),
            linear-gradient(137.95deg, #7A96AC 2.28%, #EAEFF3 19.8%, #C2D4E1 32.94%, #FFFFFF 50.16%, #D4DEE5 62.15%, #ABBDC8 78.69%, #BCCAD7 95.24%)
          `,
          backgroundOrigin: "border-box",
          backgroundClip: "padding-box, border-box",
          color: "#1F2A37",
        };
      case 3:
        return {
          background: "#E5BE96",
          border: "6.97px solid transparent",
          backgroundImage: `
            linear-gradient(#E5BE96, #E5BE96),
            linear-gradient(153.43deg, #9E8976 7.68%, #7A5E50 24.01%, #F6D0AB 42.02%, #9D774E 58.77%, #C99B70 79.3%, #795F52 91.44%)
          `,
          backgroundOrigin: "border-box",
          backgroundClip: "padding-box, border-box",
          color: "#1F2A37",
        };
      default:
        return {
          background: "#1A212F33",
          color: "#222A35",
        };
    }
  };

  const getTransferPointsStyle = (rank) => {
    switch (rank) {
      case 1:
        return {
          background:
            "linear-gradient(115.37deg, #8C421D -4.56%, #FBE67B 25.26%, #FCFBE7 44.54%, #F7D14E 66.03%, #D4A041 87.13%)",
          border: "1px solid transparent",
          backgroundImage: `
            linear-gradient(115.37deg, #8C421D -4.56%, #FBE67B 25.26%, #FCFBE7 44.54%, #F7D14E 66.03%, #D4A041 87.13%),
            linear-gradient(180deg, #CA9E52 0%, #F3E184 100%)
          `,
          backgroundOrigin: "border-box",
          backgroundClip: "padding-box, border-box",
          color: "#A37021",
        };
      case 2:
        return {
          background:
            "linear-gradient(140.73deg, #7A96AC -1.47%, #EAEFF3 17.4%, #C2D4E1 31.55%, #FFFFFF 50.09%, #D4DEE5 62.99%, #ABBDC8 80.81%, #BCCAD7 98.62%)",
          border: "1px solid transparent",
          backgroundImage: `
            linear-gradient(140.73deg, #7A96AC -1.47%, #EAEFF3 17.4%, #C2D4E1 31.55%, #FFFFFF 50.09%, #D4DEE5 62.99%, #ABBDC8 80.81%, #BCCAD7 98.62%),
            linear-gradient(180deg, #B8CADA 0%, #9BACB6 100%)
          `,
          backgroundOrigin: "border-box",
          backgroundClip: "padding-box, border-box",
          color: "#5B5B5B",
        };
      case 3:
        return {
          background:
            "linear-gradient(138.64deg, #9E8976 1.58%, #7A5E50 13.18%, #F6D0AB 48.26%, #9D774E 71.03%, #C99B70 98.92%, #795F52 115.43%)",
          border: "1px solid transparent",
          backgroundImage: `
            linear-gradient(138.64deg, #9E8976 1.58%, #7A5E50 13.18%, #F6D0AB 48.26%, #9D774E 71.03%, #C99B70 98.92%, #795F52 115.43%),
            linear-gradient(180deg, #F6D0AB 0%, #7B5F51 100%)
          `,
          backgroundOrigin: "border-box",
          backgroundClip: "padding-box, border-box",
          color: "#614B3F",
        };
      default:
        return {
          background: "#1A212F",
          color: "white",
        };
    }
  };

  const currentData =
    viewType === "clubs"
      ? leaderboardData.top_clubs
      : leaderboardData.top_agency;
  const pageTitle =
    viewType === "clubs" ? "Leaderboard_Top Clubs" : "Leaderboard_Top Agents";

  if (loading) {
    return (
      <div className="min-h-screen bg-white pb-4">
        <div className="px-4 md:px-12 py-4 flex items-center gap-3">
          <button
            onClick={handleBackClick}
            className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 transition-colors"
            aria-label="Go back"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.8333 10H4.16667M4.16667 10L10 15.8333M4.16667 10L10 4.16667"
                stroke="#222A35"
                strokeWidth="1.67"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <h1 className="text-[20px] font-bold text-[#222A35]">{pageTitle}</h1>
        </div>
        <div className="w-full py-5 bg-black rounded-b-3xl pb-32 relative">
          <div className="text-center mb-8">
            <h2
              className="text-[32px] md:text-[40px] font-medium"
              style={{
                background:
                  "linear-gradient(96.42deg, #FFFFFF 2.48%, rgba(255, 255, 255, 0) 152.62%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              Leaderboard
            </h2>
          </div>
          <div className="flex justify-center md:gap-20 gap-3">
            <div className="animate-pulse bg-white/10 rounded-[42px_42px_32px_32px] w-[180px] h-[260px] md:w-[234px] md:h-[318px]"></div>
            <div className="animate-pulse bg-white/10 rounded-[42px_42px_32px_32px] w-[180px] h-[260px] md:w-[234px] md:h-[318px]"></div>
            <div className="animate-pulse bg-white/10 rounded-[42px_42px_32px_32px] w-[180px] h-[260px] md:w-[234px] md:h-[318px]"></div>
          </div>
          <div className="animate-pulse bg-white rounded-t-3xl w-[95%] h-64 absolute -bottom-[180px] left-1/2 -translate-x-1/2"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-white pb-4">
        <div className="px-4 md:px-12 py-4 flex items-center gap-3">
          <button
            onClick={handleBackClick}
            className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 transition-colors"
            aria-label="Go back"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.8333 10H4.16667M4.16667 10L10 15.8333M4.16667 10L10 4.16667"
                stroke="#222A35"
                strokeWidth="1.67"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <h1 className="text-[20px] font-bold text-[#222A35]">{pageTitle}</h1>
        </div>
        <div className="w-full py-5 bg-black rounded-b-3xl pb-32 relative">
          <div className="text-center mb-8">
            <h2
              className="text-[32px] md:text-[40px] font-medium"
              style={{
                background:
                  "linear-gradient(96.42deg, #FFFFFF 2.48%, rgba(255, 255, 255, 0) 152.62%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              Leaderboard
            </h2>
          </div>
          <div className="flex justify-center">
            <div className="bg-white rounded-t-3xl w-[95%] h-64 absolute -bottom-[180px] left-1/2 -translate-x-1/2 flex items-center justify-center">
              <p className="text-red-500">{error}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white pb-4">
      {/* Header */}
      <div className="px-4 md:px-12 py-4 flex items-center gap-3">
        <button
          onClick={handleBackClick}
          className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 transition-colors"
          aria-label="Go back"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.8333 10H4.16667M4.16667 10L10 15.8333M4.16667 10L10 4.16667"
              stroke="#222A35"
              strokeWidth="1.67"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <h1 className="text-[18px] md:text-[20px] font-bold text-[#222A35]">{pageTitle}</h1>
      </div>

      {/* Black Background Section */}
      <div
        className="w-full py-5  rounded-b-3xl md:pb-32 relative h-[300px] md:h-auto"
        style={{
          backgroundImage: `url(${leaderboard_bg})`,
          backgroundSize: "stretch",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* Gradient Title */}
        <div className="text-center mb-6 md:mb-8">
          <h2
            className="text-[32px] md:text-[40px] font-medium"
            style={{
              background:
                "linear-gradient(96.42deg, #FFFFFF 2.48%, rgba(255, 255, 255, 0) 152.62%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            Leaderboard
          </h2>
        </div>

        {/* Three Cards Row — only render when there is real data */}
        {currentData.length === 0 ? (
          <div className="flex justify-center items-center h-[180px] md:h-[260px]">
            <p className="text-white/70 text-[16px] md:text-[18px] font-medium text-center">
              {viewType === "clubs"
                ? "No clubs on the leaderboard yet."
                : "No agencies on the leaderboard yet."}
            </p>
          </div>
        ) : (
        <div className="flex justify-center md:gap-20 gap-2">
          {/* Card 1 - 3rd Position (Bronze) */}
          <div
            className="flex flex-col items-center md:p-4 p-2 rounded-[32px_32px_24px_24px] md:rounded-[42px_42px_32px_32px] relative w-[110px] md:w-auto"
            style={{
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 58.84%)",
              border: "1.5px solid rgba(255, 255, 255, 0.28)",
            }}
          >
            {/* Inner div with diamond */}
            <div
              className="flex justify-center items-center md:p-4 p-2 rounded-[20px] md:rounded-[36px] relative w-[92px] h-[92px] md:w-auto md:h-auto"
              style={{
                background:
                  "linear-gradient(270deg, rgba(0, 0, 0, 0) 55.71%, rgba(0, 0, 0, 0.15) 99.65%)",
                border: "2.43px solid #9E8976",
              }}
            >
              <img src={Diamond_1} alt="Diamond" className="w-20 h-20 md:w-40 md:h-40" />

              {/* Rank Badge - Absolute positioned */}
              <div
                className="absolute w-7 h-7 md:w-10 md:h-10 mt-2 rounded-full flex items-center justify-center"
                style={{
                  background: "#171A46",
                  border: "2px solid #9E8976",
                  bottom: "-18px",
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              >
                <span className="text-white font-bold text-[10px] md:text-sm">3</span>
              </div>
            </div>

            {/* Club Info */}
            <div
              className="flex md:flex-row flex-col items-center gap-0.5 md:gap-2 mt-5 md:mt-8 cursor-pointer"
              onClick={() => {
                if (!currentData[2]) return;
                if (viewType === "clubs") {
                  handleClubClick(currentData[2].club_id);
                } else {
                  handleAgencyClick(currentData[2].agency_id);
                }
              }}
            >
              {viewType === "clubs" && currentData[2]?.club_logo ? (
                <img
                  src={currentData[2]?.club_logo}
                  alt={currentData[2]?.club_name}
                  className="w-4 h-4 rounded-sm object-cover"
                />
              ) : viewType === "agents" && currentData[2]?.profile_picture_url ? (
                <img
                  src={currentData[2]?.profile_picture_url}
                  alt={currentData[2]?.agency_name}
                  className="w-4 h-4 rounded-sm object-cover"
                />
              ) : (
                <div className="w-4 h-4 bg-gray-200 rounded-full flex items-center justify-center p-2">
                  <span className="text-xs text-gray-600">
                    {(currentData[2]?.club_name || currentData[2]?.agency_name || "").slice(0, 2).toUpperCase()}
                  </span>
                </div>
              )}
              <span className="text-white text-[12px] md:text-[18px] font-medium text-center md:text-left leading-tight">
                {currentData[2]?.club_name || currentData[2]?.agency_name || ""}
              </span>
            </div>
          </div>

          {/* Card 2 - 1st Position (Gold) */}
          <div
            className="flex flex-col items-center md:p-4 p-2 rounded-[32px_32px_24px_24px] md:rounded-[42px_42px_32px_32px] relative w-[110px] md:w-auto"
            style={{
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 58.84%)",
              border: "1.5px solid rgba(255, 255, 255, 0.28)",
            }}
          >
            {/* Inner div with diamond */}
            <div
              className="flex justify-center items-center md:p-4 p-2 rounded-[20px] md:rounded-[36px] relative w-[92px] h-[92px] md:w-auto md:h-auto"
              style={{
                background:
                  "linear-gradient(270deg, rgba(0, 0, 0, 0) 55.71%, rgba(0, 0, 0, 0.15) 99.65%)",
                border: "2.43px solid #F7D14E",
              }}
            >
              <img src={Diamond_2} alt="Diamond" className="w-20 h-20 md:w-40 md:h-40" />

              {/* Rank Badge - Absolute positioned */}
              <div
                className="absolute w-7 h-7 md:w-10 md:h-10 mt-2 rounded-full flex items-center justify-center"
                style={{
                  background: "#171A46",
                  border: "2px solid #F7D14E",
                  bottom: "-18px",
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              >
                <span className="text-white font-bold text-[10px] md:text-sm">1</span>
              </div>
            </div>

            {/* Club Info */}
            <div
              className="flex md:flex-row flex-col items-center gap-0.5 md:gap-2 mt-5 md:mt-8 cursor-pointer"
              onClick={() => {
                if (!currentData[0]) return;
                if (viewType === "clubs") {
                  handleClubClick(currentData[0].club_id);
                } else {
                  handleAgencyClick(currentData[0].agency_id);
                }
              }}
            >
              {viewType === "clubs" && currentData[0]?.club_logo ? (
                <img
                  src={currentData[0]?.club_logo}
                  alt={currentData[0]?.club_name}
                  className="w-4 h-4 rounded-sm object-cover"
                />
              ) : viewType === "agents" && currentData[0]?.profile_picture_url ? (
                <img
                  src={currentData[0]?.profile_picture_url}
                  alt={currentData[0]?.agency_name}
                  className="w-4 h-4 rounded-sm object-cover"
                />
              ) : ( 
                <div className="w-4 h-4 bg-gray-200 rounded-full flex items-center justify-center p-2">
                  <span className="text-xs text-gray-600">
                    {(currentData[0]?.club_name || currentData[0]?.agency_name || "").slice(0, 2).toUpperCase()}
                  </span>
                </div>
              )}
              <span className="text-white text-[12px] md:text-[18px] font-medium text-center md:text-left leading-tight">
                {currentData[0]?.club_name || currentData[0]?.agency_name || ""}
              </span>
            </div>
          </div>

          {/* Card 3 - 2nd Position (Silver) */}
          <div
            className="flex flex-col items-center md:p-4 p-2 rounded-[32px_32px_24px_24px] md:rounded-[42px_42px_32px_32px] relative w-[110px] md:w-auto"
            style={{
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 58.84%)",
              border: "1.5px solid rgba(255, 255, 255, 0.28)",
            }}
          >
            {/* Inner div with diamond */}
            <div
              className="flex justify-center items-center md:p-4 p-2 rounded-[20px] md:rounded-[36px] relative w-[92px] h-[92px] md:w-auto md:h-auto"
              style={{
                background:
                  "linear-gradient(270deg, rgba(0, 0, 0, 0) 55.71%, rgba(0, 0, 0, 0.15) 99.65%)",
                border: "2.43px solid #C2D4E1",
              }}
            >
              <img src={Diamond_3} alt="Diamond" className="w-20 h-20 md:w-40 md:h-40" />

              {/* Rank Badge - Absolute positioned */}
              <div
                className="absolute w-7 h-7 md:w-10 md:h-10 mt-2 rounded-full flex items-center justify-center"
                style={{
                  background: "#171A46",
                  border: "2px solid #C2D4E1",
                  bottom: "-18px",
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              >
                <span className="text-white font-bold text-[10px] md:text-sm">2</span>
              </div>
            </div>

            {/* Club Info */}
            <div
              className="flex md:flex-row flex-col items-center gap-0.5 md:gap-2 mt-5 md:mt-8 cursor-pointer"
              onClick={() => {
                if (!currentData[1]) return;
                if (viewType === "clubs") {
                  handleClubClick(currentData[1].club_id);
                } else {
                  handleAgencyClick(currentData[1].agency_id);
                }
              }}
            >
              {viewType === "clubs" && currentData[1]?.club_logo ? (
                <img
                  src={currentData[1]?.club_logo}
                  alt={currentData[1]?.club_name}
                  className="w-4 h-4 rounded-sm object-cover"
                />
              ) : viewType === "agents" && currentData[1]?.profile_picture_url ? (
                <img
                  src={currentData[1]?.profile_picture_url}
                  alt={currentData[1]?.agency_name}
                  className="w-4 h-4 rounded-sm object-cover"
                />
              ) : (
                <div className="w-4 h-4 bg-gray-200 rounded-full flex items-center justify-center p-2">
                  <span className="text-xs text-gray-600">
                    {(currentData[1]?.club_name || currentData[1]?.agency_name || "").slice(0, 2).toUpperCase()}
                  </span>
                </div>
              )}
              <span className="text-white text-[12px] md:text-[18px] font-medium text-center md:text-left leading-tight">
                {currentData[1]?.club_name || currentData[1]?.agency_name || ""}
              </span>
            </div>
          </div>
        </div>
        )}

        {/* Table Section */}
        <div
          className="absolute -bottom-[135px] md:-bottom-[180px] left-1/2 w-[95%] h-1/2 bg-white rounded-t-3xl 
    -translate-x-1/2 px-4 md:px-8 pt-6 md:pt-8 pb-5"
        >
          {/* Table Headers */}
          {!isMobile && (
            <div className="grid grid-cols-4 gap-4 mb-4 border-b border-[#E5E7EB] pb-3">
              <div className="text-[#1A212FB2] text-[16px] font-medium">
                Ranking
              </div>
              <div className="text-[#1A212FB2] text-[16px] font-medium">
                {viewType === "clubs" ? "Club name" : "Agency name"}
              </div>
              <div className="text-[#1A212FB2] text-[16px] font-medium">
                {viewType === "clubs" ? "Requests completed" : "Pitches completed"}
              </div>
              <div className="text-[#1A212FB2] text-[16px] font-medium">
                Transfer points
              </div>
            </div>
          )}

          {/* Table Rows */}
          <div className="space-y-3">
            {currentData.map((item, index) => {
              const rank = index + 1;
              const rankingStyle = getRankingStyle(rank);
              const transferPointsStyle = getTransferPointsStyle(rank);

              if (isMobile) {
                return (
                  <div key={item.club_id || item.agency_id} className="py-3 border-b border-[#D6DBEA]">
                    <div className="flex items-center justify-between gap-3">
                      {/* Ranking */}
                      <div className="w-8 h-8 rounded-full flex items-center justify-center text-[12px] font-bold" style={rankingStyle}>
                        {rank}
                      </div>

                      {/* Name + subtext */}
                      <div className="flex-1">
                        <div
                          className="flex items-center gap-2 cursor-pointer"
                          onClick={() =>
                            viewType === "clubs"
                              ? handleClubClick(item.club_id)
                              : handleAgencyClick(item.agency_id)
                          }
                        >
                          {viewType === "clubs" && item.club_logo ? (
                            <img src={item.club_logo} alt={item.club_name} className="w-6 h-6 rounded-full object-cover" />
                          ) : viewType === "agents" && item.profile_picture_url ? (
                            <img src={item.profile_picture_url} alt={item.agency_name} className="w-6 h-6 rounded-full object-cover" />
                          ) : (
                            <div className="w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center">
                              <span className="text-[10px] text-gray-600">
                                {(item.club_name || item.agency_name || "").slice(0, 2).toUpperCase()}
                              </span>
                            </div>
                          )}
                          <div className="flex flex-col">
                            <span className="text-[#222A35] text-[16px] font-bold leading-tight">{item.club_name || item.agency_name}</span>
                            <span className="text-[#6B7280] text-[14px] font-medium">
                              {viewType === "clubs"
                                ? `${item.tenders_completed || 0} Requests`
                                : `${item.pitches_completed || 0} Pitches`}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* TP */}
                      <div className="min-w-[80px] text-center py-1 px-2 rounded-full text-[14px] font-bold" style={transferPointsStyle}>
                        {item.tp_balance?.toLocaleString() || 0}
                      </div>
                    </div>
                  </div>
                );
              }

              // Desktop row
              return (
                <div key={item.club_id || item.agency_id} className="grid grid-cols-4 gap-4 items-center py-3 border-b border-[#D6DBEA]">
                  {/* Ranking */}
                  <div className="w-12 h-12 rounded-full flex items-center justify-center text-[16px] font-bold p-5" style={rankingStyle}>
                    {rank}
                  </div>

                  {/* Club/Agency Name */}
                  <div
                    className="flex items-center gap-3 cursor-pointer"
                    onClick={() =>
                      viewType === "clubs" ? handleClubClick(item.club_id) : handleAgencyClick(item.agency_id)
                    }
                  >
                    {viewType === "clubs" && item.club_logo ? (
                      <img src={item.club_logo} alt={item.club_name} className="w-8 h-8 rounded-full object-cover" />
                    ) : viewType === "agents" && item.profile_picture_url ? (
                      <img src={item.profile_picture_url} alt={item.agency_name} className="w-8 h-8 rounded-full object-cover" />
                    ) : (
                      <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center">
                        <span className="text-xs text-gray-600">{(item.club_name || item.agency_name || "").slice(0, 2).toUpperCase()}</span>
                      </div>
                    )}
                    <span className="text-[#222A35] text-[18px] font-bold">{item.club_name || item.agency_name}</span>
                  </div>

                  {/* Tenders/Pitches Completed */}
                  <div className="text-[#1A212F] text-[18px] font-medium">
                    {viewType === "clubs" ? item.tenders_completed || 0 : item.pitches_completed || 0}
                  </div>

                  {/* Transfer Points */}
                  <div className="min-w-[100px] text-center py-1 rounded-full text-[18px] font-bold inline-block w-fit" style={transferPointsStyle}>
                    {item.tp_balance?.toLocaleString() || 0}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Leaderboard;
